import React from 'react';
import { Grid, Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import Loader from 'utils/Loader';
import VendorLedgerDetailsController from 'pages/Controller/VendorLedgerDetailsController';

const getTransactionValue = (transaction, keys) => {
  for (const key of keys) {
    const value = transaction?.[key];
    if (value !== undefined && value !== null && value !== '') {
      return value;
    }
  }

  return '';
};

const VendorLedgerDetails = () => {
  const { ledgerData, cloading } = VendorLedgerDetailsController();

  return (
    <div className="bg" style={{ display: 'block' }}>
      {cloading ? (
        <div className="overlay">
          <Loader />
          <span style={{ marginLeft: '10px' }}>Please Wait....</span>
        </div>
      ) : null}

      <Container>
        <div className="cutrange">
          <span className="font20">Vendor Ledger Detail</span>
        </div>

        {/* Party Information Box */}
        <Paper elevation={3} sx={{ padding: '16px', backgroundColor: '#fff', mb: 2 }}>
          <Grid container spacing={2}>
            {/* Party Name */}
            <Grid item xs={6}>
              <strong>Party Name :</strong> {ledgerData?.partyDetails?.name || ''}
            </Grid>
            {/* Zone */}
            <Grid item xs={6}>
              <strong>Zone :</strong> {ledgerData?.partyDetails?.zone || ''}
            </Grid>
            {/* Party Code */}
            <Grid item xs={6}>
              <strong>Party Code :</strong> {ledgerData?.partyDetails?.partyCode || ''}
            </Grid>
            {/* City */}
            <Grid item xs={6}>
              <strong>City :</strong> {ledgerData?.partyDetails?.city || ''}
            </Grid>
            {/* <Grid item xs={6}>
              <strong>Volume of Business :</strong> {ledgerData?.partyVolume || ''}
            </Grid> */}
          </Grid>
        </Paper>

        {/* Ledger Table */}
        <TableContainer component={Paper} sx={{ maxHeight: '63vh', overflowY: 'auto' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Posting Date
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Doc. Date
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Type
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  DOC Number
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  ClearBill Doc
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Dr. Amount
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Cr. Amount
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Balance
                </TableCell>

                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Particular
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ledgerData?.transactions?.map((transaction, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor: index % 2 === 0 ? '#ffffff' : '#e0e0e0' // Zebra-striping effect
                  }}
                >
                  <TableCell align="center">{transaction.postingDate}</TableCell>
                  {/* 
                  

                  <TableCell align="center">
                    {transaction.referenceDocNo && transaction.referenceDocNoURL ? (
                      <a href={transaction.referenceDocNoURL} target="_blank" rel="noopener noreferrer">
                        {transaction.referenceDocNo}
                      </a>
                    ) : (
                      transaction.referenceDocNo ? transaction.referenceDocNo : ''
                    )}
                  </TableCell> */}

                  <TableCell align="center">{transaction.docDate}</TableCell>
                  <TableCell align="center">{transaction.type}</TableCell>
                  {/* <TableCell align="center">{getTransactionValue(transaction, ['BELNR', 'belnr'])}</TableCell> */}
                  <TableCell align="center">
                    {transaction.docNoUrl && transaction.docNoUrl !== '' ? (
                      <a href={transaction.docNoUrl} target="_blank" rel="noopener noreferrer">
                        {transaction.docNo}
                      </a>
                    ) : (
                      transaction.docNo || ''
                    )}
                  </TableCell>
                  <TableCell align="center">{getTransactionValue(transaction, ['XBLNR', 'xblnr'])}</TableCell>
                  <TableCell align="center">{transaction.drAmount}</TableCell>
                  <TableCell align="center">{transaction.crAmount}</TableCell>
                  <TableCell align="center">{transaction.balance}</TableCell>



                  <TableCell align="center">{transaction.particular}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </div>
  );
};

export default VendorLedgerDetails;
